import { render, staticRenderFns } from "./nextView.vue?vue&type=template&id=2d2b754e&scoped=true&"
import script from "./nextView.vue?vue&type=script&lang=js&"
export * from "./nextView.vue?vue&type=script&lang=js&"
import style0 from "./nextView.vue?vue&type=style&index=0&id=2d2b754e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b754e",
  null
  
)

export default component.exports